var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-12 box-shadow"},[_c('advanced',{attrs:{"col":_vm.col,"getData":_vm.getData,"DownloadURL":_vm.DownloadURL,"Options":_vm.Options,"addFilter":_vm.addFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }